import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Speedometer } from 'mdi-material-ui';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import withWidth from '@material-ui/core/withWidth';

//components
import SkillRate from './SkillRate';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            <Box p={3}>{children}</Box>
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: '#1a1c1d',
        width: "100%",
    },
    tab:{
        color: '#a8a8a8',
        width:"100%"
    }
}));

let ml = {"Keras":4,"PyTorch":3,"TensorFlow":3,"OpenAI Gym":4,"Half Field Offense (HFO)":5}
let front = {"React":4,"JavaScript":3,"HTML":5,"CSS":4,"Material-UI":4,"Bootstrap":3}
let back = {"Express.js":3,"PHP":3,"Django":2}
let data = {"MongoDB":3,"MySQL":4}
let tool = {"Linux":3,"Git":4}
let lang = {"Python":4,"Java":4,"C":4,"C++":3,"VHDL":3,"Matlab":3}
let frm = {"JavaFX":5,"OpenCV":4,"NumPy":4,"Matplotlib":3,"CUDA":3,"SystemC":3,"SFML":3,"SciPy":2,"scikit-learn":2}

function Skills(props) {
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(0);
    const xl = props.width === "xl";
    const lg = props.width === "lg";

    function handleChange(event, newValue) {
        setValue(newValue);
    }

    function handleChangeIndex(index) {
        setValue(index);
    }
    return (
        <div>
            <Typography component="div">
                <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
                    <Speedometer color="primary" style={{ fontSize: 40 }} />
                    <Box fontWeight="bold" fontSize={40} m={2}>
                        skills
                    </Box>
                </div>
            </Typography>
            <div className={classes.root}>
                <AppBar position="static" color="secondary">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                        variant="scrollable"
                        scrollButtons="on"
                    >
                        <Tab classes={{root:classes.tab}} label="Machine Learning" {...a11yProps(0)} />
                        <Tab classes={{root:classes.tab}} label="Web Development" {...a11yProps(1)} />
                        <Tab classes={{root:classes.tab}} label="Programming" {...a11yProps(2)} />
                        <Tab classes={{root:classes.tab}} label="English" {...a11yProps(3)} />
                    </Tabs>
                </AppBar>
                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >
                    <TabPanel value={value} index={0} dir={theme.direction}>
                        <SkillRate rate={3} label="Reinforcement Learing"/>
                        <Typography component="div">
                            <Box fontSize={14} m={1} style={{color:'#a8a8a8'}} textAlign="justify">
                                Q-Learning, SARSA, REINFORCE, Monte Carlo, TD-learning, Eligibility Traces, Deep Deterministic Policy Gradients, Actor-Critic, Normalized Advantage Functions, ...
                            </Box>
                        </Typography>
                        <SkillRate rate={3} label="Supervised Learing"/>
                        <Typography component="div">
                            <Box fontSize={14} m={1} style={{color:'#a8a8a8'}} textAlign="justify">
                                Fully Connected Neural Networks, Convolutional Neural Networks, Recurrent Neural Network, Haar Cascades, Support Vector Machines, ...
                            </Box>
                        </Typography>
                        <Typography component="div" >
                            <Box fontSize={20} fontWeight="bold" m={1} style={{marginTop:20}}>
                                Frameworks and Tools
                            </Box>
                        </Typography>
                        {
                            Object.keys(ml).map(item => <SkillRate key={item} rate={ml[item]} label={item} />)
                        }
                    </TabPanel>
                    <TabPanel value={value} index={1} dir={theme.direction} >
                        <div style={{display:"flex",flexDirection:"column",height:"80%",overflow:"auto",width:"100%"}}>
                            <Typography component="div" >
                                <Box fontSize={20} fontWeight="bold" m={1}>
                                    Front-End
                                </Box>
                            </Typography>
                            {
                                Object.keys(front).map(item => <SkillRate key={item} rate={front[item]} label={item} />)
                            }
                            
                            
                            <Typography component="div" >
                                <Box fontSize={20} fontWeight="bold" m={1} style={{marginTop:20}}>
                                    Back-End
                                </Box>
                            </Typography>
                            {
                                Object.keys(back).map(item => <SkillRate key={item} rate={back[item]} label={item} />)
                            }
                            {lg|xl?(<div></div>):(<Typography component="div">
                                <Box fontSize={14} m={1} style={{color:'#1c1e1f'}} textAlign="justify">
                                    Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back Back
                                </Box>
                            </Typography>)}
                            
                            <Typography component="div" >
                                <Box fontSize={20} fontWeight="bold" m={1} style={{marginTop:20}}>
                                    Database
                                </Box>
                            </Typography>
                            {
                                Object.keys(data).map(item => <SkillRate rate={data[item]} label={item} />)
                            }
                            <Typography component="div" >
                                <Box fontSize={20} fontWeight="bold" m={1} style={{marginTop:20}}>
                                    Tools
                                </Box>
                            </Typography>
                            {
                                Object.keys(tool).map(item => <SkillRate rate={tool[item]} label={item} />)
                            }
                        </div>
                    </TabPanel>
                    <TabPanel value={value} index={2} dir={theme.direction}>
                        <Typography component="div" >
                            <Box fontSize={20} fontWeight="bold" m={1}>
                                Programming Languages
                            </Box>
                        </Typography>
                        {
                            Object.keys(lang).map(item => <SkillRate rate={lang[item]} label={item} />)
                        }
                        {lg|xl?<div></div>:(<Typography component="div">
                            <Box fontSize={14} m={1} style={{color:'#1c1e1f'}} textAlign="justify">
                                Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang Lang
                            </Box>
                        </Typography>)}
                        
                        <Typography component="div" >
                            <Box fontSize={20} fontWeight="bold" m={1} style={{marginTop:20}}>
                                Frameworks and Libaries
                            </Box>
                        </Typography>
                        {
                            Object.keys(frm).map(item => <SkillRate key={item} rate={frm[item]} label={item} />)
                        }
                    </TabPanel>
                    <TabPanel value={value} index={3} dir={theme.direction}>
                        
                        <Typography component="div" >
                            <Box fontSize={16} fontWeight="bold" m={1} style={{marginTop:20,background:"#00b277",padding:"0 10px"}}>
                                IELTS
                            </Box>
                        </Typography>
                        <div style={{display:"flex",flexWrap:"wrap"}}>
                            <div style={{padding:10}}>Overall: 8</div>
                            <div style={{padding:10}}>Listening: 9</div>
                            <div style={{padding:10}}>Reading: 8.5 </div>
                            <div style={{padding:10}}>Writing: 6.5</div>
                            <div style={{padding:10}}>Speaking: 7</div>
                        </div>
                        <Typography component="div" >
                            <Box fontSize={16} fontWeight="bold" m={1} style={{marginTop:20,background:"#00b277",padding:"0 10px"}}>
                                GRE
                            </Box>
                        </Typography>              
                        <div style={{padding:10}}>To be taken</div>
                    </TabPanel>
                </SwipeableViews>
            </div>
        </div>
    )

    
}

export default withWidth()(Skills);